import querystring from 'querystring';

export const makeCouponQs = (coupon = '') => coupon && `/?${querystring.stringify({ coupon })}`;
